export function formatPhoneNumber(input: string): string {
  if (!input) {
    return input; // Return as is if input is invalid
  }

  const parts = input.split(','); // Split the input by commas
  if (parts.length === 0) {
    return input; // Return as is if there are no parts
  }

  const firstPart = `(${parts[0].trim()})`; // Enclose the first part in parentheses
  const restParts = parts.slice(1).map((part) => part.trim()); // Trim and handle remaining parts

  return [firstPart, ...restParts].join(' '); // Combine the formatted parts
}
